import { dumpIcons, type DumpIconName } from "../generated/dump-icons";

type DumpIconProps = {
  name: DumpIconName;
  class?: string;
};

export function DumpIcon(props: DumpIconProps) {
  return (
    <span
      class={`icon_container_IconGetter flex h-full items-center justify-center ${props.class ?? ""}`}
      // The SVG registry is generated from the immutable supplied dump.
      innerHTML={dumpIcons[props.name]}
    />
  );
}
